import { render, staticRenderFns } from "./HostControls.vue?vue&type=template&id=04f75b9e&scoped=true"
import script from "./HostControls.vue?vue&type=script&lang=js"
export * from "./HostControls.vue?vue&type=script&lang=js"
import style0 from "./HostControls.vue?vue&type=style&index=0&id=04f75b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f75b9e",
  null
  
)

export default component.exports